/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

/**
 * Checks if the character passed in is an Arabic character.
 * @param {string} charCode - Character code
 * @return {boolean} True, if character is an Arabic character, false otherwise
 */
function isArabicChar(charCode) {
	if (
		(charCode >= 0x0600 && charCode <= 0x0669) ||
		(charCode >= 0x06fa && charCode <= 0x07ff) ||
		(charCode >= 0xfb50 && charCode <= 0xfdff) ||
		(charCode >= 0xfe70 && charCode <= 0xfefc)
	) {
		return true;
	}

	return false;
}

/**
 * Checks if the character passed in is a Hebrew character.
 * @param {string} charCode - Character code
 * @return {boolean} True, if character is a Hebrew character, false otherwise
 */
function isHebrewChar(charCode) {
	if (charCode >= 0x05d0 && charCode <= 0x05ff) {
		return true;
	}

	return false;
}

/**
 * Checks if the character passed in is a BiDi character.
 * @param {number} charCode - Character code
 * @return {boolean} True, if the character is a BiDi (Arabic or Hebrew) character, false otherwise
 */
function isBidiChar(charCode) {
	return isArabicChar(charCode) || isHebrewChar(charCode);
}

/**
 * Checks if the character passed in is a Latin character (Only treats
 * capital and lower case alphabets as latin characters)
 * @param {number} charCode - Character code
 * @return {boolean} True if the character is a Latin character, false otherwise
 */
function isLatinChar(charCode) {
	if ((charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123)) {
		return true;
	}

	return false;
}

function detectIE(useragent) {
	return /\b(MSIE|Trident|Edge)\b/.test(useragent);
}

const AUTO = 'auto';
const isIE = detectIE(navigator.userAgent);

/**
 * Traverses the string passed in as a parameter from the beginning and
 * determines the direction of the text based on the first strong character
 * @param {string} text - A bi-directional text
 * @param {bool} isTextArea - Does the text belong to a textarea
 * @return {string} Direction of the text
 */
export function resolveBaseTextDir(text, textDir, isTextArea) {
	// eslint-disable-line import/prefer-default-export
	if (!textDir) {
		textDir = AUTO;
	}
	if (textDir === AUTO && (!isTextArea || isIE)) {
		for (let i = 0; text && i < text.length; i++) {
			const character = text.charCodeAt(i);
			if (isBidiChar(character)) {
				textDir = 'rtl';
				break;
			} else if (isLatinChar(character)) {
				textDir = 'ltr';
				break;
			}
		}
		if (isIE && textDir === AUTO) {
			textDir = '';
		}
	}

	return textDir;
}
